<script>
export default {
  props: {
    name: String,
    attr: Object,
    option: String,
    checked: String,
    value: String,
    validate: {default:""},
    disabled: Boolean,
  },
  data(){
    return {
      input: this.value,
    }
  },
  methods:{
    onClick(){
      this.$emit('input', this.option)
      setTimeout(()=>$(this.$el).find("input").valid(), 10)
    }
  },
  watch:{
    input(v){ this.$emit("input", v); },
    value(v){ this.input = v; },
  }
}
</script>

<template>
  <div class="inline radio radio-info" @click="onClick">
    <input class="radio-style" type="radio" v-model="input" :name="name" :value="option" v-bind="attr">
    <label for="radio-21" class="radio-style-2-label"><slot></slot></label>
  </div>
</template>
